// removed by extract-text-webpack-plugin
module.exports = {"btnPrimary":"btnPrimary___3b-v5","header":"header___1bfe7","sepLine":"sepLine___3sGOe"};